import * as React from 'react';
import { Invoice } from 'fs-api-client';
import { createBillingApi } from '../../utils/createApi';
import { Subtract } from '../../utils/types';
import { LoaderEnhancerProperties, withLoader } from './LoaderEnhancer';
import { errorHandler } from '../../services/errorHandler';

export interface BillingInvoicesInjectorProperties extends LoaderEnhancerProperties {
    fetchBillingInvoices: (showLoader: boolean) => Promise<Invoice[]>;
    billingInvoices: Invoice[];
    errorMessage?: string;
}

interface BillingInvoicesInjectorState {
    billingInvoices: Invoice[] | null;
    errorMessage?: string;
}

let cache: Invoice[] | null = null;

export function injectBillingInvoices<P extends BillingInvoicesInjectorProperties>(component: React.ComponentType<P>) {
    const loaderName = 'billingInvoicesInjector';
    let DynamicComponent: any = withLoader(component, loaderName);

    return class BillingInvoicesInjector extends React.Component<Subtract<P, BillingInvoicesInjectorProperties>, BillingInvoicesInjectorState> {
        private isCompMounted: boolean = false;

        constructor(props: P) {
            super(props);

            this.fetchBillingInvoices = this.fetchBillingInvoices.bind(this);

            this.state = {
                billingInvoices: cache
            };
        }

        componentDidMount() {
            this.isCompMounted = true;
            this.fetchBillingInvoices();
        }

        componentWillUnmount() {
            this.isCompMounted = false;
        }

        render() {
            return (
                <DynamicComponent
                    {...this.props}
                    loading={!this.state.billingInvoices}
                    fetchBillingInvoices={this.fetchBillingInvoices}
                    billingInvoices={this.state.billingInvoices}
                    errorMessage={this.state.errorMessage}
                />
            );
        }

        private async fetchBillingInvoices(): Promise<Invoice[] | null> {
            try {
                const billingApi = await createBillingApi();
                const invoices = (await billingApi.getInvoices()).body;
                cache = invoices;
                if (this.isCompMounted) {
                    this.setState({ billingInvoices: invoices });
                }
                return invoices;
            } catch (e) {
                this.setState({ errorMessage: 'Could not load invoices. Check your connection to the server and try again.' });
                errorHandler(e);
                return null;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/webportal/components/hocs/BillingInvoicesInjector.tsx